import {useApiErrorHandler} from '@karpeleslab/klb-react-services';
import {useCallback} from 'react';
import {rest} from '@karpeleslab/klbfw';

export const useGeoLookup = () => {
	const [catchRedirect] = useApiErrorHandler();

	const fetch = useCallback(
		() => {
			return rest('ThirdParty/Geoip:lookup', 'GET')
				.then(catchRedirect)
				.then(d => d);
		}
		, []);

	return [fetch];
};
